export default __webpack_public_path__ + "static/media/SWT0160.34I-20234_-16352_0.8ccacf96.jpg";